import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import './index.css'
import App from './App.jsx'

// Handle chunk loading failures (happens when new deploy has different chunk hashes)
// This catches the "Failed to fetch dynamically imported module" errors
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('Failed to fetch dynamically imported module')) {
    // Show a user-friendly message and reload
    if (confirm('A new version of the app is available. Click OK to refresh.')) {
      window.location.reload();
    }
  }
});

// Also handle unhandled promise rejections for dynamic imports
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message &&
      (event.reason.message.includes('Failed to fetch dynamically imported module') ||
       event.reason.message.includes('Loading chunk') ||
       event.reason.message.includes('Loading CSS chunk'))) {
    event.preventDefault();
    if (confirm('A new version of the app is available. Click OK to refresh.')) {
      window.location.reload();
    }
  }
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>,
)
